import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './sleep.json';

const Sleep = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Sleep science, health benefits, and vocabulary. B2 level grammar, reading, and discussion exercises."
            level="B2"
            title="Sleep"
            image="/Images/sleep.webp"
            seoTitle="Free English Lesson Plans: Sleep"
            seoDescription="Sleep science, health benefits, and vocabulary. B2 level grammar, reading, and discussion exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Sleep;


